import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 32,
  },
  path: {
    fill: '#7df3e1',
  },
  stopZero: {
    stopColor: '#33B7BE',
  },
  stopShift: {
    stopColor: '#318CCA',
  },
  logoFirst: {
    fill: 'url(#logo-first)',
  },
  logoSecond: {
    fill: 'url(#logo-second)',

  },
  logoThird: {
    fill: 'url(#logo-third)',
  },
  name: {
    fill: '#318CCA',
  }
});
const PlattLogoFull = () => {
  const classes = useStyles();

  return (
<svg
  className={classes.svg}
  version="1.1"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 1698 501.8">
  <g>
    <g>
      <g>
        <linearGradient id="logo-first" gradientUnits="userSpaceOnUse" x1="261.0725" y1="61.0546" x2="114.7503" y2="320.0845">
          <stop  offset="0" className={classes.stopZero} />
          <stop  offset="0.699" className={classes.stopShift} />
        </linearGradient>
        <path className={classes.logoFirst}
          d="M194.6,177.2c3.2,1.9,6.8,2.8,10.3,2.8c7.1,0,14-3.7,17.8-10.3l59.4-102.9c5.7-9.8,2.3-22.4-7.5-28.1
          c-9.8-5.7-22.4-2.3-28.1,7.5L187,149.1C181.4,159,184.7,171.6,194.6,177.2z"/>
        
          <linearGradient id="logo-second" gradientUnits="userSpaceOnUse" x1="435.7719" y1="159.7398" x2="289.4497" y2="418.7697">
          <stop  offset="0" className={classes.stopZero} />
          <stop  offset="0.699" className={classes.stopShift} />
        </linearGradient>
        <path className={classes.logoSecond} 
          d="M395.4,424.7H153.6
          c-11.4,0-20.6,9.2-20.6,20.6c0,11.4,9.2,20.6,20.6,20.6h241.7c11.4,0,20.6-9.2,20.6-20.6C415.9,433.9,406.7,424.7,395.4,424.7z"
          />
        
          <linearGradient id="logo-third" gradientUnits="userSpaceOnUse" x1="305.1048" y1="85.9278" x2="158.7826" y2="344.9577">
          <stop  offset="0" className={classes.stopZero} />
          <stop  offset="0.699" className={classes.stopShift} />
        </linearGradient>
        <path className={classes.logoThird}
          d="M429.5,234.3l-68.6-118.8
          c-3.7-6.4-10.5-10.3-17.8-10.3h-47.2c0.4,0,0.7,0.1,1.1,0.1c-3.7-0.1-7.5,0.7-10.9,2.7c-9.8,5.7-13.2,18.3-7.5,28.1l26.6,46.1
          l-56.7,98.2H135l-56.7-98.2L135,84h53.2c11.4,0,20.6-9.2,20.6-20.6s-9.2-20.6-20.6-20.6h-65.1c-7.3,0-14.1,3.9-17.8,10.3
          L36.8,171.9c-3.7,6.4-3.7,14.2,0,20.6l68.6,118.8c3.7,6.4,10.5,10.3,17.8,10.3H192l0,0h-34l30.1,52.1
          c3.7,6.4,10.5,10.3,17.8,10.3h137.1c7.3,0,14.1-3.9,17.8-10.3l68.6-118.8C433.1,248.5,433.1,240.6,429.5,234.3z M299,105.5
          c-0.2,0-0.4-0.1-0.6-0.1C298.6,105.4,298.8,105.5,299,105.5z"/>
      </g>
    </g>
    <g>
      <g>
        <path className={classes.name}
          d="M778.3,113.3h-44.7h-66.2l-5.3,60.7l-5.6,64.4l-5.3,60.7l-7.4,84.8h66.2l7.4-84.8H762l0,0
          c51.3,0,96.5-41.6,101-92.9S829.6,113.3,778.3,113.3z M767.3,238.4h-44.7l5.6-64.4h44.7c17.8,0,30.9,14.4,29.4,32.2
          C800.8,223.9,785.1,238.4,767.3,238.4z"/>
        <polygon className={classes.name}
          points="885.1,383.9 945.8,383.9 969.5,113.3 908.8,113.3"/>
        <polygon className={classes.name}
          points="1278.6,174 1332,174 1313.6,383.9 1382.7,383.9 1401.1,174 1454.1,174 1459.4,113.3 1283.9,113.3"/>
        <polygon className={classes.name} 
          points="1488.5,113.3 1483.1,174 1536.5,174 1518.2,383.9 1587.3,383.9 1605.7,174 1658.7,174 1664,113.3"/>
        <path className={classes.name}
          d="M1182.6,189.9c-15.6-10.2-34.6-16.1-55.4-16.1c-59.9,0-112.6,48.5-117.9,108.4
          c-5.2,59.9,39,108.4,98.9,108.4c20.8,0,40.8-5.9,58.2-16.1l-0.8,9.4h60.7l17.8-203h-60.7L1182.6,189.9z M1110.2,333.1
          c-28,0-48.7-22.7-46.2-50.7s27.1-50.7,55.1-50.7c28,0,48.7,22.7,46.2,50.7C1162.9,310.4,1138.2,333.1,1110.2,333.1z"/>
      </g>
    </g>
  </g>
</svg>

  );
};

export default PlattLogoFull;
